import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import useAdminStyles from './adminStyles';
import { STATUS_LABELS } from './StatusChip';

export const PLANS = ['FREE', 'TRIAL', 'SPECIAL', 'BASIC', 'PREMIUM'];
const STATUSES = Object.keys(STATUS_LABELS);
const LOGIN_WINDOWS = [
    { value: '', label: 'Any time' },
    { value: '7', label: 'Last 7 days' },
    { value: '30', label: 'Last 30 days' },
    { value: '90', label: 'Last 90 days' },
    { value: '365', label: 'Last year' },
];

/**
 * Filter bar for the users table. `filters` = { search, plan, status, lastLoginDays, excludeGuests }.
 * The search box is debounced so typing does not fire a request per keystroke.
 * `hidePlan` is used by the Subscriptions tab, which picks the plan with pills instead.
 */
const UsersFilters = ({ filters, onChange, hidePlan = false }) => {
    const classes = useAdminStyles();
    const [search, setSearch] = useState(filters.search || '');

    useEffect(() => {
        setSearch(filters.search || '');
    }, [filters.search]);

    useEffect(() => {
        if (search === (filters.search || '')) {
            return undefined;
        }
        const handle = setTimeout(() => onChange({ ...filters, search }), 400);
        return () => clearTimeout(handle);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const set = (key) => (event) => onChange({ ...filters, [key]: event.target.value });

    return (
        <div className={classes.filters}>
            <TextField
                className={classes.filterSearch}
                variant="outlined"
                size="small"
                label="Search email or name"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
            />
            {hidePlan ? null : (
                <FormControl variant="outlined" size="small" className={classes.filterControl}>
                    <InputLabel id="admin-filter-plan">Plan</InputLabel>
                    <Select labelId="admin-filter-plan" label="Plan" value={filters.plan || ''} onChange={set('plan')}>
                        <MenuItem value="">All plans</MenuItem>
                        {PLANS.map((plan) => (
                            <MenuItem key={plan} value={plan}>
                                {plan}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
            <FormControl variant="outlined" size="small" className={classes.filterControl}>
                <InputLabel id="admin-filter-status">Status</InputLabel>
                <Select labelId="admin-filter-status" label="Status" value={filters.status || ''} onChange={set('status')}>
                    <MenuItem value="">All statuses</MenuItem>
                    {STATUSES.map((status) => (
                        <MenuItem key={status} value={status}>
                            {STATUS_LABELS[status]}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl variant="outlined" size="small" className={classes.filterControl}>
                <InputLabel id="admin-filter-login">Last login</InputLabel>
                <Select
                    labelId="admin-filter-login"
                    label="Last login"
                    value={filters.lastLoginDays || ''}
                    onChange={set('lastLoginDays')}
                >
                    {LOGIN_WINDOWS.map((w) => (
                        <MenuItem key={w.value || 'any'} value={w.value}>
                            {w.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControlLabel
                control={
                    <Switch
                        color="primary"
                        checked={filters.excludeGuests !== false}
                        onChange={(event) => onChange({ ...filters, excludeGuests: event.target.checked })}
                    />
                }
                label="Hide guests"
            />
        </div>
    );
};

export default UsersFilters;
